export default __webpack_public_path__ + "static/heart@2x-1b33a0832bc2272999d99d60de1138e0.png";